import React from "react";
import Parceiro from "../../components/classes/Parceiro";
import AcompanhamentoCargaGridFOB from "./gridFob";

import { confirmAlert } from "react-confirm-alert";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

export default function AcompanhamentoCargaFOBDetalhes() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const parceiro: Parceiro = JSON.parse(
    String(localStorage.getItem("ParceiroSelecionado"))
  );

  const validarParceiroSelecionado = () => {
    if (!parceiro)
      confirmAlert({
        title: t("pages.deliveriesFob.text.requiredField"),
        message: t("pages.deliveriesFob.text.selectPartnerFirst"),
        buttons: [{
          label: t("common.ok"), onClick: () => {
            navigate('/');
          }
        }]
      });

    return (
      parceiro ?
        <AcompanhamentoCargaGridFOB parceiro={parceiro} />
        :
        <div />
    );
  }

  return (validarParceiroSelecionado());
}
